import styled from 'styled-components';
import {
  Checkbox,
} from 'antd';
import {
  COLOR_CV_6,
} from 'constants/colors';

export const StyledAntdCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    &, &:hover {
      background-color: ${COLOR_CV_6};
      border-color: ${COLOR_CV_6};
    }
  }

  .ant-checkbox-checked {
    &, &::after {
      border-color: ${COLOR_CV_6};
    }
  }

  &.ant-checkbox-wrapper:hover .ant-checkbox-inner,
  &.ant-checkbox:hover &.ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${COLOR_CV_6};
  }
`;
